import { createApi } from '@reduxjs/toolkit/query/react'
import { CHATTER_PROGRAM_LIST, CHATTER_PROGRAM_CREATE, CHATTER_PROGRAM_DELETE, CHATTER_PROGRAM_DETAILS, CHATTER_PROGRAM_EDIT, CHATTER_PROGRAM_REMOVE_LESSON, CHATTER_PROGRAM_ADD_USER, CHATTER_PROGRAM_ADD_REMOVE, MANAGE_CHATTER_PROGRAM_ATTENDANCE, CHATTER_PEER_EVALUATE, CHATTER_PEER_SHARE_EVALUATION } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const chatterProgramApi = createApi({
    reducerPath: 'chatterProgramApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/programs",
    }),
    tagTypes: ["ChatterProgram", "ChatterProgramDetails"],
    endpoints: (builder) => ({

        // get program list
        getChatterProgramList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, therapist_head1 = "", sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: CHATTER_PROGRAM_LIST,
                data: { search, status, page, limit, therapist_head1, sort },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterProgram"]
        }),

        // create chatter program
        createChatterProgram: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: CHATTER_PROGRAM_CREATE,
                data
            }),
            invalidatesTags: ["ChatterProgram"]
        }),

        // delete chatter program
        deleteChatterProgram: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${CHATTER_PROGRAM_DELETE}/${id}`
            }),
            invalidatesTags: ["ChatterProgram", "ChatterProgramDetails"]
        }),

        // chatter program details
        chatterProgramDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${CHATTER_PROGRAM_DETAILS}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            invalidatesTags: ["ChatterProgram"],
            providesTags: ["ChatterProgramDetails"]
        }),

        // update chatter client
        updateChatterProgram: builder.mutation({
            query: ({ data, programId }) => ({
                method: "PUT",
                url: `${CHATTER_PROGRAM_EDIT}/${programId}`,
                data
            }),
            invalidatesTags: ["ChatterProgram", "ChatterProgramDetails"]
        }),

        // remove assigned chatter lesson
        removeAssignedLesson: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${CHATTER_PROGRAM_REMOVE_LESSON}/${id}`
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        // add user
        addProgramUser: builder.mutation({
            query: ({ data, programId }) => ({
                method: "POST",
                url: `/${programId}${CHATTER_PROGRAM_ADD_USER}`,
                data
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        // remove user
        removeProgramUser: builder.mutation({
            query: ({ data, programId }) => ({
                method: "POST",
                url: `/${programId}${CHATTER_PROGRAM_ADD_REMOVE}`,
                data
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        // mark attendance
        markAttendance: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_CHATTER_PROGRAM_ATTENDANCE}/${id}`,
                data
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        evaluatePeer: builder.mutation({
            query: ({ programId, peerId, data }) => ({
                method: "POST",
                url: `${CHATTER_PEER_EVALUATE}/${programId}/${peerId}`,
                data
            }),
            invalidatesTags: ["ChatterProgramDetails"]
        }),

        shareEvaluation: builder.mutation({
            query: ({ programId, peerId, therapistHead, sessionDate }) => ({
                method: "GET",
                url: `${CHATTER_PEER_SHARE_EVALUATION}/${programId}/${peerId}/${therapistHead}/${sessionDate}`,
            })
        }),
    })
})

export const {
    useGetChatterProgramListQuery,
    useCreateChatterProgramMutation,
    useDeleteChatterProgramMutation,
    useChatterProgramDetailsQuery,
    useUpdateChatterProgramMutation,
    useRemoveAssignedLessonMutation,
    useAddProgramUserMutation,
    useRemoveProgramUserMutation,
    useMarkAttendanceMutation,
    useEvaluatePeerMutation,
    useShareEvaluationMutation,
} = chatterProgramApi;